import { Grid, TextField, Button } from "@material-ui/core";
import { Card } from "@material-ui/core";
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import { useDispatch } from "react-redux";
import { UpdateUsersList } from "../../store/actions";
import Typography from "@material-ui/core/Typography";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const AddTag = (props) => {
  const expanded = useCustomState(false);
  const handleExpandClick = () => {
    expanded.handleChange(!expanded.value);
  };

  const name = useCustomState("");
  const description = useCustomState("");
  const selectedFile = useCustomState("");
  const tagImages = useCustomState([]);

  const nameError = useCustomState({ error: false, text: "" });

  const nameChanged = (e) => {
    nameError.handleChange({ error: false, text: "" });
    name.handleChange(e.target.value);
  };
  const descriptionChanged = (e) => {
    description.handleChange(e.target.value);
  };

  const tagImagesChanged = (e) => {
    const files = e.target.files;
    tagImages.handleChange(files);
    selectedFile.handleChange(e.target.value);
  };

  const dispatch = useDispatch();

  const addTag = (e) => {
    const tagName = name.value;
    let tagDescription = description.value;
    let hasError = false;
    // check required fields
    if (tagName.length == 0) {
      nameError.handleChange({
        error: true,
        text: "وارد کردن نام دسته الزامی است.",
      });
      hasError = true;
    }
    if (tagDescription.length == 0) {
      tagDescription = "وارد نشده";
    }
    if (hasError) {
      return;
    }
    const files = tagImages.value;
    const json = {
      water_meter_tag_name: tagName,
      water_meter_tag_other_information: {
        description: tagDescription,
      },
    };

    const data = new FormData();
    data.append("data", JSON.stringify(json));
    if (files.length > 0) {
      data.append("file", files[0]);
    }

    Call("POST", "WaterMeterTags/admin/add", data)
      .then((response) => {
        if (response.data.code == 200) {
          name.handleChange("");
          description.handleChange("");
          tagImages.handleChange([]);
          selectedFile.handleChange("");
        }
      })
      .catch((error) => {
        const data = error.response.data;
        // console.log(data);
      });
  };

  return (
    <Grid container style={{ paddingRight: "16px", paddingLeft: "16px" }}>
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Card style={{ width: "100%", marginTop: "16px" }}>
          <CardHeader
            style={{ borderBottom: "2px solid #e6e9ed", color: "#73879c" }}
            title={"افزودن دسته جدید"}
            action={
              <ExpandMoree
                expand={expanded.value}
                onClick={handleExpandClick}
                aria-expanded={expanded.value}
                aria-label="show more"
              >
                <ExpandMore />
              </ExpandMoree>
            }
          />
          <Collapse in={expanded.value} timeout="auto" unmountOnExit>
            <CardContent
              style={{
                padding: "16px",
                // maxHeight: "320px",
                overflow: "scroll",
              }}
            >
              <Grid
                container
                style={{ paddingTop: "24px", paddingBottom: "24px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    error={nameError.value.error}
                    helperText={nameError.value.text}
                    onChange={nameChanged}
                    value={name.value}
                    fullWidth
                    variant="standard"
                    label="نام دسته"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <TextField
                    onChange={descriptionChanged}
                    value={description.value}
                    fullWidth
                    variant="filled"
                    multiline
                    rows={8}
                    maxRows={12}
                    label="توضیحات"
                    InputLabelProps={{
                      style: {
                        fontFamily: "Vazir",
                      },
                    }}
                    size="small"
                  ></TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Typography>انتخاب تصویر</Typography>
                  <input
                    style={{
                      border: "1px solid #333",
                      padding: "6px",
                      borderRadius: "4px",
                    }}
                    onChange={tagImagesChanged}
                    value={selectedFile.value}
                    type="file"
                    accept=".jpg, .png, .svg, .PNG, .JPG, .JPEG, .jpeg"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    paddingRight: "5%",
                    paddingLeft: "5%",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Button
                    onClick={addTag}
                    style={{ color: "#fff" }}
                    variant="contained"
                    color="primary"
                  >
                    افزودن
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Collapse>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AddTag;
